import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { InputGroup, Table } from "react-bootstrap-v5";
import { searchPurchaseProduct } from "../../store/action/purchaseProductAction";
import { editPurchaseReturn } from "../../store/action/purchaseReturnAction";
import status from "../../shared/option-lists/status.json";
import {
    fetchAllProducts,
    fetchProductsByWarehouse,
} from "../../store/action/productAction";
import PurchaseReturnTable from "../../shared/components/purchase/PurchaseTable";
import { preparePurchaseReturnArray } from "./preparePurchaseReturnArray";
import {
    decimalValidate,
    getFormattedMessage,
    placeholderText,
    onFocusInput,
} from "../../shared/sharedMethod";
import {
    calculateCartTotalAmount,
    calculateCartTotalTaxAmount,
} from "../../shared/calculation/calculation";
import ModelFooter from "../../shared/components/modelFooter";
import ProductSearch from "../../shared/components/product-cart/search/ProductSearch";
import { addToast } from "../../store/action/toastAction";
import { toastType } from "../../constants";
import ReactDatePicker from "../../shared/datepicker/ReactDatePicker";
import ProductMainCalculation from "../sales/ProductMainCalculation";
import ReactSelect from "../../shared/select/reactSelect";

const PurchaseReturnForm = (props) => {
    const {
        addPurchaseReturnData,
        id,
        editPurchaseReturn,
        customProducts,
        singlePurchase,
        warehouses,
        suppliers,
        fetchProductsByWarehouse,
        products,
        frontSetting,
        allConfigData,
    } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [newCost, setNewCost] = useState("");
    const [newDiscount, setNewDiscount] = useState("");
    const [newTax, setNewTax] = useState("");
    const [newPurchaseUnit, setNewPurchaseUnit] = useState("");
    const [subTotal, setSubTotal] = useState("");
    const [updateProducts, setUpdateProducts] = useState([]);
    const [quantity, setQuantity] = useState(0);

    const [purchaseValue, setPurchaseValue] = useState({
        date: singlePurchase
            ? moment(singlePurchase.date).toDate()
            : new Date(),
        warehouse_id: singlePurchase ? singlePurchase.warehouse_id : "",
        supplier_id: singlePurchase ? singlePurchase.supplier_id : "",
        tax_rate: singlePurchase ? singlePurchase.orderTax.toFixed(2) : "0.00",
        tax_amount: singlePurchase ? singlePurchase.tax_amount : "0.00",
        discount: singlePurchase ? singlePurchase.discount.toFixed(2) : "0.00",
        shipping: singlePurchase ? singlePurchase.shipping.toFixed(2) : "0.00",
        grand_total: singlePurchase ? singlePurchase.grand_total : "0.00",
        notes: singlePurchase ? singlePurchase.notes : "",
        status_id: singlePurchase
            ? singlePurchase.status_id
            : { label: "Received", value: 1 },
    });

    const [errors, setErrors] = useState({
        date: "",
        warehouse_id: "",
        supplier_id: "",
        details: "",
        tax_rate: "",
        discount: "",
        shipping: "",
        status_id: "",
    });

    useEffect(() => {
        setUpdateProducts(updateProducts);
    }, [
        updateProducts,
        quantity,
        newCost,
        newDiscount,
        newTax,
        subTotal,
        newPurchaseUnit,
    ]);

    useEffect(() => {
        updateProducts.length >= 1
            ? dispatch({ type: "DISABLE_OPTION", payload: true })
            : dispatch({ type: "DISABLE_OPTION", payload: false });
    }, [updateProducts]);

    useEffect(() => {
        if (singlePurchase) {
            setUpdateProducts(singlePurchase.purchase_return_items);
        }
    }, []);

    useEffect(() => {
        purchaseValue.warehouse_id.value
            ? fetchProductsByWarehouse(purchaseValue?.warehouse_id?.value)
            : null;
    }, [purchaseValue.warehouse_id]);

    const handleValidation = () => {
        let errorss = {};
        let isValid = false;
        const qtyCart = updateProducts.filter((a) => a.quantity === 0);
        if (!purchaseValue.date) {
            error["date"] = getFormattedMessage("globally.date.validate.label");
        } else if (!purchaseValue.warehouse_id) {
            errorss["warehouse_id"] = getFormattedMessage(
                "purchase.select.warehouse.validate.label"
            );
        } else if (!purchaseValue.supplier_id) {
            errorss["supplier_id"] = getFormattedMessage(
                "purchase.select.supplier.validate.label"
            );
        } else if (qtyCart.length > 0) {
            dispatch(
                addToast({
                    text: getFormattedMessage(
                        "globally.product-quantity.validate.message"
                    ),
                    type: toastType.ERROR,
                })
            );
        } else if (updateProducts.length < 1) {
            dispatch(
                addToast({
                    text: getFormattedMessage(
                        "purchase.product-list.validate.message"
                    ),
                    type: toastType.ERROR,
                })
            );
        } else if (!purchaseValue.status_id) {
            errorss["status_id"] = getFormattedMessage(
                "globally.status.validate.label"
            );
        } else {
            isValid = true;
        }
        setErrors(errorss);
        return isValid;
    };

    const onWarehouseChange = (obj) => {
        setPurchaseValue((inputs) => ({ ...inputs, warehouse_id: obj }));
        setErrors("");
    };

    const onSupplierChange = (obj) => {
        setPurchaseValue((inputs) => ({ ...inputs, supplier_id: obj }));
        setErrors("");
    };

    const onStatusChange = (obj) => {
        setPurchaseValue((inputs) => ({ ...inputs, status_id: obj }));
    };

    const updateCost = (item) => {
        setNewCost(item);
    };

    const updateDiscount = (item) => {
        setNewDiscount(item);
    };

    const updateTax = (item) => {
        setNewTax(item);
    };

    const onChangeInput = (e) => {
        e.preventDefault();
        const { value } = e.target;
        // check if value includes a decimal point
        if (value.match(/\./g)) {
            const [, decimal] = value.split(".");
            // restrict value to only 2 decimal places
            if (decimal?.length > 2) {
                // do nothing
                return;
            }
        }
        setPurchaseValue((inputs) => ({
            ...inputs,
            [e.target.name]: value && value,
        }));
    };

    const onNotesChangeInput = (e) => {
        e.preventDefault();
        setPurchaseValue((inputs) => ({ ...inputs, notes: e.target.value }));
    };

    const handleCallback = (date) => {
        setPurchaseValue((previousState) => {
            return { ...previousState, date: date };
        });
        setErrors("");
    };

    const updatedQty = (qty) => {
        setQuantity(qty);
    };

    const updateSubTotal = (item) => {
        setSubTotal(item);
    };

    const updatePurchaseUnit = (item) => {
        setNewPurchaseUnit(item);
    };

    const prepareData = (prepareData) => {
        const formValue = {
            date: moment(prepareData.date).toDate(),
            warehouse_id: prepareData.warehouse_id.value
                ? prepareData.warehouse_id.value
                : prepareData.warehouse_id,
            supplier_id: prepareData.supplier_id.value
                ? prepareData.supplier_id.value
                : prepareData.supplier_id,
            discount: prepareData.discount,
            tax_rate: prepareData.tax_rate,
            tax_amount: calculateCartTotalTaxAmount(
                updateProducts,
                purchaseValue
            ),
            purchase_return_items: updateProducts,
            shipping: prepareData.shipping,
            grand_total: calculateCartTotalAmount(
                updateProducts,
                purchaseValue
            ),
            received_amount: "",
            paid_amount: "",
            payment_type: 0,
            notes: prepareData.notes,
            reference_code: "",
            status: prepareData.status_id.value
                ? prepareData.status_id.value
                : prepareData.status_id,
            payment_status: 2,
        };
        return formValue;
    };

    const onSubmit = (event) => {
        event.preventDefault();
        const valid = handleValidation();
        if (valid) {
            if (singlePurchase) {
                editPurchaseReturn(id, prepareData(purchaseValue), navigate);
            } else {
                addPurchaseReturnData(prepareData(purchaseValue));
                setPurchaseValue(purchaseValue);
            }
        }
    };

    const onBlurInput = (el) => {
        if (el.target.value === "") {
            if (el.target.name === "shipping") {
                setPurchaseValue({ ...purchaseValue, shipping: "0.00" });
            }
            if (el.target.name === "discount") {
                setPurchaseValue({ ...purchaseValue, discount: "0.00" });
            }
            if (el.target.name === "tax_rate") {
                setPurchaseValue({ ...purchaseValue, tax_rate: "0.00" });
            }
        }
    };

    return (
        <div className="card">
            <div className="card-body">
                {/*<Form>*/}
                <div className="row">
                    <div className="col-md-4">
                        <label className="form-label">
                            {getFormattedMessage(
                                "react-data-table.date.column.label"
                            )}
                            :
                        </label>
                        <span className="required" />
                        <div className="position-relative">
                            <ReactDatePicker
                                onChangeDate={handleCallback}
                                newStartDate={purchaseValue.date}
                            />
                        </div>
                        <span className="text-danger d-block fw-400 fs-small mt-2">
                            {errors["date"] ? errors["date"] : null}
                        </span>
                    </div>
                    <div className="col-md-4 mb-5">
                        <ReactSelect
                            data={warehouses}
                            onChange={onWarehouseChange}
                            defaultValue={purchaseValue.warehouse_id}
                            addSearchItems={singlePurchase}
                            isWarehouseDisable={true}
                            title={getFormattedMessage("warehouse.title")}
                            errors={errors["warehouse_id"]}
                            placeholder={placeholderText(
                                "purchase.select.warehouse.placeholder.label"
                            )}
                        />
                    </div>
                    <div className="col-md-4">
                        <ReactSelect
                            data={suppliers}
                            onChange={onSupplierChange}
                            defaultValue={purchaseValue.supplier_id}
                            title={getFormattedMessage("supplier.title")}
                            errors={errors["supplier_id"]}
                            placeholder={placeholderText(
                                "purchase.select.supplier.placeholder.label"
                            )}
                        />
                    </div>
                    <div className="col-md-12 mb-5">
                        <label className="form-label">
                            {getFormattedMessage(
                                "dashboard.stockAlert.product.label"
                            )}
                            :
                        </label>
                        <ProductSearch
                            values={purchaseValue}
                            products={products}
                            isAllProducts={true}
                            handleValidation={handleValidation}
                            updateProducts={updateProducts}
                            setUpdateProducts={setUpdateProducts}
                            customProducts={customProducts}
                        />
                    </div>
                    <div className="col-12 md-12">
                        <label className="form-label">
                            {getFormattedMessage(
                                "purchase.order-item.table.label"
                            )}
                            :
                        </label>
                        <span className="required " />
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>
                                        {getFormattedMessage(
                                            "dashboard.stockAlert.product.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "purchase.order-item.table.net-unit-cost.column.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "purchase.order-item.table.stock.column.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "purchase.order-item.table.qty.column.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "purchase.order-item.table.discount.column.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "purchase.order-item.table.tax.column.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "purchase.order-item.table.sub-total.column.label"
                                        )}
                                    </th>
                                    <th>
                                        {getFormattedMessage(
                                            "react-data-table.action.column.label"
                                        )}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {updateProducts &&
                                    updateProducts.map(
                                        (singleProduct, index) => {
                                            return (
                                                <PurchaseReturnTable
                                                    key={
                                                        index +
                                                        100 * Math.random()
                                                    }
                                                    singleProduct={
                                                        singleProduct
                                                    }
                                                    index={index}
                                                    updateQty={updatedQty}
                                                    updateProducts={
                                                        updateProducts
                                                    }
                                                    updateCost={updateCost}
                                                    updateDiscount={
                                                        updateDiscount
                                                    }
                                                    updateSubTotal={
                                                        updateSubTotal
                                                    }
                                                    frontSetting={frontSetting}
                                                    updateTax={updateTax}
                                                    setUpdateProducts={
                                                        setUpdateProducts
                                                    }
                                                    updatePurchaseUnit={
                                                        updatePurchaseUnit
                                                    }
                                                    purchaseItem={
                                                        singlePurchase &&
                                                        singlePurchase.purchase_return_items
                                                    }
                                                />
                                            );
                                        }
                                    )}
                                {!updateProducts.length && (
                                    <tr>
                                        <td
                                            colSpan={8}
                                            className="fs-5 px-3 py-6 custom-text-center"
                                        >
                                            {getFormattedMessage(
                                                "sale.product.table.no-data.label"
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <div className="col-12">
                        <ProductMainCalculation
                            inputValues={purchaseValue}
                            allConfigData={allConfigData}
                            updateProducts={updateProducts}
                            frontSetting={frontSetting}
                        />
                    </div>
                    <div className="col-md-4 mb-5">
                        <label className="form-label">
                            {getFormattedMessage(
                                "purchase.input.order-tax.label"
                            )}
                            :
                        </label>
                        <InputGroup>
                            <input
                                aria-label="Dollar amount (with dot and two decimal places)"
                                value={purchaseValue.tax_rate}
                                type="text"
                                name="tax_rate"
                                onKeyPress={(event) => decimalValidate(event)}
                                className="form-control"
                                onBlur={(event) => onBlurInput(event)}
                                onFocus={(event) => onFocusInput(event)}
                                onChange={(e) => {
                                    onChangeInput(e);
                                }}
                            />
                            <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup>
                        <span className="text-danger d-block fw-400 fs-small mt-2">
                            {errors["orderTax"] ? errors["orderTax"] : null}
                        </span>
                    </div>
                    <div className="col-md-4 mb-5">
                        <label className="form-label">
                            {getFormattedMessage(
                                "purchase.order-item.table.discount.column.label"
                            )}
                            :
                        </label>
                        <InputGroup>
                            <input
                                aria-label="Dollar amount (with dot and two decimal places)"
                                value={purchaseValue.discount}
                                type="text"
                                name="discount"
                                className="form-control"
                                onBlur={(event) => onBlurInput(event)}
                                onFocus={(event) => onFocusInput(event)}
                                onKeyPress={(event) => decimalValidate(event)}
                                onChange={(e) => onChangeInput(e)}
                            />
                            <InputGroup.Text>
                                {frontSetting.value &&
                                    frontSetting.value.currency_symbol}
                            </InputGroup.Text>
                        </InputGroup>
                        <span className="text-danger d-block fw-400 fs-small mt-2">
                            {errors["discount"] ? errors["discount"] : null}
                        </span>
                    </div>
                    <div className="col-md-4 mb-5">
                        <label className="form-label">
                            {getFormattedMessage(
                                "purchase.input.shipping.label"
                            )}
                            :
                        </label>
                        <InputGroup>
                            <input
                                aria-label="Dollar amount (with dot and two decimal places)"
                                type="text"
                                value={purchaseValue.shipping}
                                name="shipping"
                                className="form-control"
                                onBlur={(event) => onBlurInput(event)}
                                onFocus={(event) => onFocusInput(event)}
                                onKeyPress={(event) => decimalValidate(event)}
                                onChange={(e) => onChangeInput(e)}
                            />
                            <InputGroup.Text>
                                {frontSetting.value &&
                                    frontSetting.value.currency_symbol}
                            </InputGroup.Text>
                        </InputGroup>
                        <span className="text-danger d-block fw-400 fs-small mt-2">
                            {errors["shipping"] ? errors["shipping"] : null}
                        </span>
                    </div>
                    <div className="col-md-4">
                        <ReactSelect
                            name="status"
                            data={status}
                            onChange={onStatusChange}
                            title={getFormattedMessage(
                                "purchase.select.status.label"
                            )}
                            defaultValue={purchaseValue.status_id}
                            errors={errors["status_id"]}
                            placeholder={placeholderText(
                                "purchase.select.status.placeholder.label"
                            )}
                        />
                    </div>
                    <div className="col-md-12 mb-5">
                        <label className="form-label">
                            {getFormattedMessage("globally.input.notes.label")}:
                        </label>
                        <textarea
                            name="notes"
                            className="form-control"
                            value={purchaseValue.notes}
                            placeholder={placeholderText(
                                "purchase.placeholder.notes.input"
                            )}
                            onChange={(e) => onNotesChangeInput(e)}
                        />
                        <span className="text-danger d-block fw-400 fs-small mt-2">
                            {errors["notes"] ? errors["notes"] : null}
                        </span>
                    </div>
                    <ModelFooter
                        onEditRecord={singlePurchase}
                        onSubmit={onSubmit}
                        link="/admin/pos/purchase-return"
                    />
                </div>
                {/*</Form>*/}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const { purchaseProducts, products, frontSetting, allConfigData } = state;
    return {
        customProducts: preparePurchaseReturnArray(products),
        purchaseProducts,
        products,
        frontSetting,
        allConfigData,
        fetchAllProducts,
    };
};

export default connect(mapStateToProps, {
    editPurchaseReturn,
    fetchProductsByWarehouse,
    searchPurchaseProduct,
    fetchAllProducts,
})(PurchaseReturnForm);
